import { createContext, useState, useContext, useMemo } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [schools, setSchools] = useState([]); // will load from API only for super admin
  const [pageTitle, setPageTitle] = useState("");

  const value = useMemo(
    () => ({
      user,
      setUser,
      schoolId,
      setSchoolId,
      schools,
      setSchools,
      pageTitle,
      setPageTitle,
    }),
    [user, schoolId, schools, pageTitle]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => useContext(AppContext);
